import {
  setFetcherSettingsBrandTraceData,
  setFetcherSettingsDetailsData,
  setFetcherSettingsDevObjsData,
  setFetcherSettingsMainTablesData,
} from "../../../features/fetcherSettingsSlice";
import { setDisplayErrorSnackBar } from "../../../features/userSlice";
import { fetcherSettingsService } from "../../../services/api/fetcher-settings.endpoints";
import store from "../../../store";

async function getFetcherSettingsData({
  oauthTokenHeader,
  queryId,
  websiteSharedUids,
  //dimension,
}: {
  oauthTokenHeader: string;
  queryId: string;
  websiteSharedUids: string[];
  // dimension: string[];
}) {
  try {
    const response = await fetcherSettingsService.getFetcherSettingsData({
      oauthTokenHeader,
      queryId,
      websiteSharedUids,
    });
    if (!response?.status || response.status !== 200) {
      throw new Error();
    }
    store.dispatch(
      setFetcherSettingsMainTablesData(response?.data?.data || []),
    );
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message:
          e?.parsedText ||
          "Failed to fetch fetcher settings data. Please try again later or Refresh the page.",
        type: "error",
      }),
    );
  }
}
async function getFetcherSettingsDetailsData({
  oauthTokenHeader,
  queryId,
  websiteSharedUids,
  item_id,
  level,
}: {
  oauthTokenHeader: string;
  queryId: string;
  websiteSharedUids: string[];
  item_id: any;
  level: any;
}) {
  try {
    const response = await fetcherSettingsService.getFetcherSettingsData({
      oauthTokenHeader,
      queryId,
      websiteSharedUids,
      item_id,
      level,
    });
    if (!response?.status || response.status !== 200) {
      throw new Error();
    }
    store.dispatch(setFetcherSettingsDetailsData(response?.data?.data || []));
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message:
          e?.parsedText ||
          "Failed to fetch fetcher settings details data. Please try again later or Refresh the page.",
        type: "error",
      }),
    );
  }
}
async function getFetcherSettingsDevObjsData({
  oauthTokenHeader,
  queryId,
  websiteSharedUids,
  item_id,
  level,
}: {
  oauthTokenHeader: string;
  queryId: string;
  websiteSharedUids: string[];
  item_id: any;
  level: any;
}) {
  try {
    const response = await fetcherSettingsService.getFetcherSettingsData({
      oauthTokenHeader,
      queryId,
      websiteSharedUids,
      item_id,
      level,
    });
    if (!response?.status || response.status !== 200) {
      throw new Error();
    }
    store.dispatch(setFetcherSettingsDevObjsData(response?.data?.data || []));
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message:
          e?.parsedText ||
          "Failed to fetch fetcher settings (Dev Objects) data. Please try again later or Refresh the page.",
        type: "error",
      }),
    );
  }
}
async function getFetcherSettingsBrandTraceData({
  oauthTokenHeader,
  queryId,
  websiteSharedUids,
  brand_id,
}: {
  oauthTokenHeader: string;
  queryId: string;
  websiteSharedUids: string[];
  brand_id: string;
}) {
  try {
    const response = await fetcherSettingsService.getFetcherSettingsData({
      oauthTokenHeader,
      queryId,
      websiteSharedUids,
      brand_id,
    });
    if (!response?.status || response.status !== 200) {
      throw new Error();
    }
    store.dispatch(
      setFetcherSettingsBrandTraceData(response?.data?.data || []),
    );
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message:
          e?.parsedText ||
          "Failed to fetch Brand data. Please try again later or Refresh the page.",
        type: "error",
      }),
    );
  }
}

export const FetcherSettingsEndPointLogic = {
  getFetcherSettingsData,
  getFetcherSettingsDetailsData,
  getFetcherSettingsDevObjsData,
  getFetcherSettingsBrandTraceData,
};
